import React from 'react';

export default ({ color = '#BDBDBD' }) => (
  <svg width="24" height="24" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_28018_7960)">
      <path
        d="M7.05371 7.05371L12.947 12.947"
        stroke={color}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.88095 10.7618C6.23012 11.4126 5.17512 11.4126 4.52428 10.7618L2.15512 8.39262C1.50428 7.74178 1.50428 6.68678 2.15512 6.03595L6.03595 2.15512C6.68678 1.50428 7.74178 1.50428 8.39262 2.15512L10.7618 4.52428C11.4126 5.17512 11.4126 6.23012 10.7618 6.88095"
        stroke={color}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.23813 13.119C8.58729 13.7698 8.58729 14.8248 9.23813 15.4756L11.6073 17.8448C12.2581 18.4956 13.3131 18.4956 13.964 17.8448L17.8448 13.964C18.4956 13.3131 18.4956 12.2581 17.8448 11.6073L15.4756 9.23813C14.8248 8.58729 13.7698 8.58729 13.119 9.23813"
        stroke={color}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_28018_7960">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
